export default "__VITE_ASSET__Cl$41FuO__"